import React from "react";
import cx from "classnames";
import ReactSlider from "react-slick";
import { StaticImage } from "gatsby-plugin-image";

import { Heading } from "components/ui/Heading";
import { Container } from "components/common/Container";
import { Section } from "components/common/Section";

import { IProduct, ProductCard } from "./ProductCard";
import * as s from "./Products.module.sass";

const sliderSettings = {
  slidesToShow: 3,
  slidesToScroll: 3,
  dots: false,
  infinite: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        arrows: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        arrows: false,
      },
    },
  ],
};

type ProductsProps = {
  products: (IProduct & { id: string })[];
};

export const Products: FC<ProductsProps> = ({ products, className }) => (
  <Section className={cx(s.root, className)} id="products">
    <Container>
      <Heading>Our products</Heading>
    </Container>
    <Container className={s.container}>
      <ReactSlider {...sliderSettings} className={s.slider}>
        {products.map(({ id, ...product }, index) => (
          <div key={id}>
            <ProductCard
              product={product}
              glassType={(index % 3) as 0 | 1 | 2}
              className={s.product}
            />
          </div>
        ))}
      </ReactSlider>
      <div className={s.waves}>
        <StaticImage
          src="../../../images/home-products-waves.png"
          objectFit="contain"
          loading="eager"
          placeholder="none"
          quality={80}
          alt="Our products"
        />
      </div>
    </Container>
  </Section>
);
